export default __webpack_public_path__ + "static/media/feb3.f2bfa015.jpg";